import { Fragment } from 'react';
import type { ReactNode } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface DrawerLateralProps {
  isOpen: boolean;
  titulo: string;
  onClose: () => void;
  children: ReactNode;
  rodape?: ReactNode;
  erros?: string[];
}

/** Drawer à direita no padrão dos do SI (editor de documento, nova versão, histórico). */
export function DrawerLateral({ isOpen, titulo, onClose, children, rodape, erros = [] }: DrawerLateralProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        </Transition.Child>
        <div className="fixed inset-0 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="flex h-full w-full max-w-xl flex-col overflow-hidden bg-white shadow-xl">
              <div className="flex items-center justify-between border-b border-raro-gray-200 p-4">
                <Dialog.Title className="font-montserrat text-lg font-semibold text-raro-gray-900">{titulo}</Dialog.Title>
                <button type="button" className="text-raro-gray-400 hover:text-raro-gray-500" onClick={onClose}>
                  <span className="sr-only">Fechar</span>
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              <div className="flex-1 space-y-4 overflow-y-auto p-5">{children}</div>
              {erros.length > 0 && (
                <ul className="space-y-0.5 border-t border-rose-100 bg-rose-50 px-5 py-2 text-xs text-rose-700">
                  {erros.map((erro) => (
                    <li key={erro}>• {erro}</li>
                  ))}
                </ul>
              )}
              {rodape && <div className="flex flex-wrap justify-end gap-3 border-t border-raro-gray-200 p-4">{rodape}</div>}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
